/**
 * The empty cart drawer's own links.
 *
 * "Continue shopping" pointed at the catalogue unconditionally, so pressing it
 * while already on the catalogue reloaded the page you were reading and left
 * the drawer sitting open on top of it. The material shortcuts did the same
 * when you were already on that material.
 *
 * A link that would land you where you already are has nothing to navigate to.
 * It closes the drawer instead, through `<theme-drawer>`'s own close, so it
 * leaves the same way it arrived and the page underneath does not move.
 *
 * A link that does go somewhere navigates as normal, and closes the drawer on
 * its way out, so the material you asked for is not delivered underneath an
 * open cart.
 */
(() => {
  'use strict';

  const LINKS = '.tonus-cart-empty__shop, .tonus-cart-empty__collection';
  const path = (value) => (value || '').replace(/\/+$/, '') || '/';

  /* Continue shopping means the catalogue. On the catalogue, or on the home
     page which opens onto it, there is nowhere further to send anyone. */
  const alreadyShopping = () => {
    const here = path(location.pathname);
    return here === '/' || here.startsWith('/collections');
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.(LINKS);
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;

    const drawer = link.closest('theme-drawer');
    if (!drawer || typeof drawer.close !== 'function') return;

    const samePage = path(link.pathname) === path(location.pathname);
    const shopFromShopping = link.classList.contains('tonus-cart-empty__shop') && alreadyShopping();

    if (!samePage && !shopFromShopping) {
      /* A real destination. The drawer still closes, it just does not swallow
         the click: the page transition can carry it, and nobody arrives at the
         material they asked for with the cart still sitting over it. */
      drawer.close();
      return;
    }

    event.preventDefault();
    drawer.close();
  });
})();
